import React, { Component } from 'react';
import Frontpageanimation from '../frontpageanimation/frontpageanimation';
import Frontpageupdates from '../frontpageupdates/frontpageupdates';
import Menutoggler from '../menutoggler/menutoggler';
import Menu from '../menu/menu';

import './frontpage.css';

class Frontpage extends Component {
    render() {
        return (
            <div className="frontpage">
                <div className="frontpage__left">
                    <Menu/>
                    <div className="frontpage__intro">
                        <Menutoggler/>
                        <Frontpageanimation/>
                    </div>
                </div>
                <div className="frontpage__right">
                    <Frontpageupdates/>
                </div>
            </div>
        );
    }
}

export default Frontpage;



// WEBPACK FOOTER //
// ./src/components/frontpage/frontpage.js